<div class="projectable-form-wrapper"
     (keyup.enter)="save($event)"
     (keyup.escape)="closeModal(false)"
     tabindex="0"
     [class.projectable-form-hidden]="!dataInit"
>
    <lib-form-header
            [data]="formData"
            [title]="(formData.id ? 'Edit Config' : 'Create Config')"
            [moreActions]="formData.moreActions"
            (actionRequested)="headerActionRequested($event)"
            [(formView)]="formView"
            [saveDisabled]="svc.saveDisabled || formDataInvalid"
            [saveTooltip]="saveButtonTooltip"
            [class.is-scrolled]="isScrolled"
    ></lib-form-header>
    <div class="config-form-container projectable-form-container" #formContainer>
        <div class="projectable-form-main-column form-group-row" [hidden]="formView !== 'simple'">
            <div class="form-group-column three-fifths">
                <lib-form-field-container [title]="'Config Name'" [label]="'Required'">
                    <input
                        id="ConfigName"
                        type="text"
                        maxlength="500"
                        placeholder="Name this config"
                        [ngClass]="{error: errors['name']}"
                        [(ngModel)]="formData.name"
                        (keyup)="apiData()"
                    >
                </lib-form-field-container>
                <lib-form-field-container [showHeader]="false">
                    <div class="config-title-row">
                        <span class="form-field-title">Configuration Data</span>
                        <div class="form-header-toggle-container">
                                        <span
                                                class="toggle-option-text"
                                                [ngClass]="{'toggle-option-selected': !svc.configJsonView}"
                                                (click)="svc.toggleJSONView()"
                                        >
                                            FORM
                                        </span>
                            <div class="form-header-toggle" (click)="svc.toggleJSONView()">
                                <div
                                        class="form-toggle-switch"
                                        [ngClass]="{'toggle-left': !svc.configJsonView, 'toggle-right': svc.configJsonView}"
                                >
                                    <div class="form-toggle-indicator"></div>
                                    <div class="form-toggle-indicator"></div>
                                </div>
                            </div>
                            <span
                                    class="toggle-option-text"
                                    [ngClass]="{'toggle-option-selected': svc.configJsonView}"
                                    (click)="svc.toggleJSONView()"
                            >
                                            JSON
                                        </span>
                        </div>
                    </div>
                    <div class="form-field-input-group">
                        <div class="config-title-row">
                            <span class="form-field-title">{{isEditing ? 'Config Type' : 'Select a Config Type'}}</span>
                        </div>
                        <select
                                id="ConfigTypes"
                                class="config-type-select"
                                [(ngModel)]="formData.configTypeId"
                                (change)="getSchema()"
                                [ngClass]="{disabled: isEditing, error: errors['configTypeId']}"
                        >
                            <option value="">Select A Type...</option>
                            <option *ngFor="let config of options"
                                    [value]="config.id">{{config.name}}
                            </option>
                        </select>
                        <lib-config-editor
                                [hidden]="configTypeEmpty"
                                [schema]="selectedSchema"
                                [(configData)]="formData.data"
                                [showJsonView]="svc.configJsonView"
                                [(configErrors)]="errors"
                                (configDataChange)="dataChanged($event)"
                                #configEditor
                        ></lib-config-editor>
                    </div>
                </lib-form-field-container>
                <lib-form-field-toggle [(toggleOn)]="showMore" (toggleOnChange)="showMoreChanged($event)" style="margin: 0px 10px"></lib-form-field-toggle>
                <div [hidden]="!showMore" class="form-group-column">
                    <lib-form-field-container
                            [title]="'Custom Tags'"
                            [label]="'OPTIONAL'"
                            class="form-field-advanced"
                            *ngIf="!hideTags"
                    >
                        <lib-custom-tags [(tags)]="formData.tags"></lib-custom-tags>
                    </lib-form-field-container>
                </div>
            </div>
            <div class="form-group-column two-fifths">
                <lib-form-field-container
                        [title]="'API Calls'"
                        [label]="''"
                        [headerActions]="apiOptions"
                        (actionRequested)="apiActionRequested($event)"
                >
                    <div class="form-row">
                        <input class="form-field-input" [value]="apiCallURL" readonly/>
                        <div class="url-copy icon-copy copy-text" (click)="copyToClipboard(apiCallURL)"></div>
                    </div>
                    <lib-json-view *ngIf="formData" [(data)]="_apiData" [readOnly]="true" [showCopy]="true"></lib-json-view>
                </lib-form-field-container>
            </div>
        </div>
        <div class="form-group-column" *ngIf="formView === 'raw'">
            <lib-json-view *ngIf="formData" [(data)]="formData"></lib-json-view>
        </div>
    </div>
</div>
<lib-loading-indicator *ngIf="isLoading || !dataInit" [isLoading]="isLoading || !dataInit"></lib-loading-indicator>
